import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/Col/index.js
// module id = 387
// module chunks = 0